import React, { useState } from "react";
import moment from "moment";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import EdModal from "@frameworks/web/components/generic/edModal";
import DownloadReportPopupDesk from "@frameworks/web/components/generic/DownloadReports/DownloadReportPopupDesk";
import { ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import Drawer from "react-bottom-drawer";
import PopupFail from "../HoldingReports/SMCaseLoadPopup/SmcasePopupFail";
import PopupLoader from "../HoldingReports/SMCaseLoadPopup/SmcasePopupLoader";
import SuccessPopup from "../HoldingReports/SMCaseLoadPopup/SmcasePopupSuccess";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import CommonDownloadReport from "../CommonComponent/CommonDownloadReport";
import { DateRangeExceedsOneYear, LedgerTabsType, downloadRestrictionForComm, sortlistLedger, } from "./Constants";
import di from "@frameworks/web/components/Reports/LedgerReports/di/servicelocator";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { useSelector } from "react-redux";
import { dynamicLedgerFilters, } from "@domains/aggregates/interfaces/Reports/iLedgerReport";
import { FilterData, Filters, } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { LEDGER_COMM_ENTITY, LEDGER_REPORT_TYPE, } from "@domains/entities/interfaces/Reports/LedgerReport/ILedgerReport";
import Ledger_CP_Header from "./Ledger_CP_Header";
import FilterLabels from "@frameworks/web/components/generic/FilterLabels/FilterLabels";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import SortFilter, { SORTFILTERTABS, } from "@frameworks/web/components/features/Offerings/SGB/common/SortFilter";
import mainDI from "@frameworks/web/di/index";
import { ESortOrder } from "@domains/utils/sort";
import LedgerFilter from "./LedgerFilter";
import { threePaths } from "../DpInterest/DpInterestMobileTable";
import SmcasePopupLoaderMob from "../HoldingReports/SMCaseLoadPopup/SmcasePopupLoaderMob";
import SmcasePopupSuccessMob from "../HoldingReports/SMCaseLoadPopup/SmcasePopupSuccessMob";
import SmcasePopupFailMob from "../HoldingReports/SMCaseLoadPopup/SmcasePopupFailMob";
import { isEqual } from "underscore";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
import { useParams } from "react-router-dom";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
import { LoginSource } from "@domains/utils/emtReportCallback";
const LedgerCommonPanel = (props) => {
    const filterRef = React.useRef(null);
    const reportName = getQueryParameterName("reportName");
    const tabname = getQueryParameterName("tab");
    const { loginSource } = useParams();
    const sales_native_app = JSON.parse(localStorage.getItem("sales_native_app"));
    const VoucherFilterSession = JSON.parse(sessionStorage.getItem("simpleFilter"));
    const ExchangeFilterSession = JSON.parse(sessionStorage.getItem("assetFilter"));
    const device = DeviceContext();
    const { detail: detail } = useSelector((state) => state.LedgerReport.detail.reducersData, isEqual);
    const [operation, setOperation] = useState("");
    const [downloadLoader, setDownloadLoader] = useState(false);
    const [downloadSuccess, setDownloadSuccess] = useState(false);
    const [downloadFail, setDownloadFail] = useState(false);
    // interalDates are for download popup
    const [internalStartDate, setInternalStartDate] = useState(props.startDate);
    const [internalEndDate, setInternalEndDate] = useState(props.endDate);
    const [filterData, setFilterData] = React.useState(detail.filterData);
    const [sortState, setSortState] = React.useState(sortlistLedger);
    const [downloadCheck, setDownloadCheck] = useState(false);
    const [emailCheck, setEmailCheck] = useState(false);
    //mob sort filter
    const [stateUpdateFilter, setStateUpdateFilter] = React.useState();
    const [finalSortState, setFinalSortState] = React.useState({});
    const [showAllEmails, setShowAllEmails] = React.useState(false);
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const isClientLogin = loginSource !== LoginSource.SALES &&
        !sales_native_app &&
        !isImpersonated &&
        lgnSrc !== ELoginSource.NESTTRADER;
    const closeDrawerLoader = React.useCallback(() => setDownloadLoader(false), []);
    const closeDrawerDownloadS = React.useCallback(() => setDownloadSuccess(false), []);
    const closeDrawerFail = React.useCallback(() => setDownloadFail(false), []);
    const downloadEmailCOMEQHandler = (D_E_Payload) => {
        switch (props.accType) {
            case ILoginAccountTypes.COMEQ:
                if (props.COMEQTOGGLE === ILoginAccountTypes.CO) {
                    D_E_Payload.AccType = ILoginAccountTypes.CO;
                    D_E_Payload.entity = LEDGER_COMM_ENTITY.EBL;
                    D_E_Payload.currentValue = "1";
                }
                else if (props.COMEQTOGGLE === ILoginAccountTypes.EQ) {
                    D_E_Payload.AccType = ILoginAccountTypes.EQ;
                    D_E_Payload.isMTF = props.MTFToggle;
                    D_E_Payload.segment = props.selectedSegmentFilter.value;
                    D_E_Payload.currentValue = "1";
                }
                break;
            case ILoginAccountTypes.CO:
                D_E_Payload.AccType = ILoginAccountTypes.CO;
                D_E_Payload.entity = LEDGER_COMM_ENTITY.EBL;
                D_E_Payload.currentValue = "1";
                break;
            case ILoginAccountTypes.EQ:
                D_E_Payload.AccType = ILoginAccountTypes.EQ;
                D_E_Payload.isMTF = props.MTFToggle;
                D_E_Payload.segment = props.selectedSegmentFilter.value;
                D_E_Payload.currentValue = "1";
                break;
        }
    };
    const downloadAndEmailLedger = (email, download) => {
        props.setDownloadPopUp(false);
        setDownloadLoader(true);
        setShowAllEmails(false);
        if (email) {
            email.accodes = props === null || props === void 0 ? void 0 : props.acccodes;
            downloadEmailCOMEQHandler(email);
            if (props.selectedTab === LedgerTabsType.SNAPSHOT)
                email.ledgerType = LEDGER_REPORT_TYPE.SNAPSHOT;
            else
                email.ledgerType = LEDGER_REPORT_TYPE.DETAIL;
        }
        if (download) {
            download.accodes = props === null || props === void 0 ? void 0 : props.acccodes;
            downloadEmailCOMEQHandler(download);
            if (props.selectedTab === LedgerTabsType.SNAPSHOT)
                download.ledgerType = LEDGER_REPORT_TYPE.SNAPSHOT;
            else
                download.ledgerType = LEDGER_REPORT_TYPE.DETAIL;
        }
        di.ledger
            .downloadAndSendLedgerReport(email, download)
            .then((resp) => {
            if (resp)
                setDownloadSuccess(resp);
            else
                setDownloadFail(resp);
            setDownloadLoader(false);
        })
            .catch((err) => {
            setDownloadFail(true);
            setDownloadLoader(false);
        });
    };
    const applyFilter = (filterData, filterTrayOpen) => {
        props.setSelectedFilterTray(filterTrayOpen);
        setFilterData(filterData);
        di.ledger.getFilteredLedgerDetails(new FilterData(filterData.simpleFilter, filterData.assetFilter, di.ledger.filterState.productAssetFilter));
    };
    const sortLedgerDetailsReport = (id) => {
        props.setshowFilterAssetDropdown(false);
        props.setSortOrFilterActiveKey(SORTFILTERTABS.SORT);
        setSortState((sort) => {
            var _a;
            setFinalSortState(JSON.parse(JSON.stringify((_a = sort[id === null || id === void 0 ? void 0 : id.parentId]) === null || _a === void 0 ? void 0 : _a.list[id === null || id === void 0 ? void 0 : id.childId])));
            return sort;
        });
    };
    const DownloadSubmitButtonText = () => {
        if ((downloadCheck && emailCheck) || (!downloadCheck && !emailCheck))
            return React.createElement(React.Fragment, null, "Download and Send Report");
        if (downloadCheck)
            return React.createElement(React.Fragment, null, "Download Report");
        if (emailCheck)
            return React.createElement(React.Fragment, null, "Send Report");
    };
    const modalTitleDwnldEmail = () => {
        if (downloadCheck && emailCheck)
            return "Downloading and Sharing Ledger";
        if (downloadCheck)
            return "Download Ledger";
        if (emailCheck)
            return "Send Ledger";
    };
    const FailureMessage = () => {
        if (downloadCheck && emailCheck)
            return "please try to download and share the report again!";
        if (downloadCheck)
            return "please try to download the report again!";
        if (emailCheck)
            return "please try to share the report again!";
    };
    const loaderMessage = () => {
        if (downloadCheck && emailCheck)
            return "Download and Share";
        if (downloadCheck)
            return "download";
        if (emailCheck)
            return "send";
    };
    const downloadSuccessNode = () => {
        if (downloadCheck && emailCheck)
            return (React.createElement("div", { className: "DMSans_16_500  text-center txt_primaryGrey" },
                "Your Ledger Report is successfully Downloaded and Shared with ",
                React.createElement("br", null),
                device && (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement("div", { className: "txt-midnight-blue" }, di.ledger.emailList.length <= 3 ? (di.ledger.emailList.join()) : (React.createElement(React.Fragment, null,
                    di.ledger.emailList.slice(0, 3).join(),
                    React.createElement(GenericTooltip, { placement: "right", button: React.createElement("span", null,
                            "and",
                            " ",
                            React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline" },
                                di.ledger.emailList.length - 3,
                                " More",
                                " ",
                                di.ledger.emailList.length - 3 === 1
                                    ? "email"
                                    : "emails")), toolTipText: React.createElement(React.Fragment, null, di.ledger.emailList.slice(3).map((x) => (React.createElement("div", null, x)))), triggerType: "click", toolTipClassName: "download-email-tooltip", externalClassName: "remove-btn-props" }))))) : (React.createElement("div", { className: "txt-midnight-blue" }, di.ledger.emailList.length <= 3 || showAllEmails ? (di.ledger.emailList.map((item, index) => (React.createElement("div", { key: index }, index < di.ledger.emailList.length - 1
                    ? `${item}, `
                    : item)))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", null, di.ledger.emailList.slice(0, 3).join(", ")),
                    React.createElement("div", null,
                        "and",
                        " ",
                        React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline", onClick: () => {
                                setShowAllEmails((prevValue) => !prevValue);
                            } },
                            di.ledger.emailList.length - 3,
                            " More",
                            " ",
                            di.ledger.emailList.length - 3 === 1
                                ? "email"
                                : "emails"))))))));
        if (downloadCheck)
            return (React.createElement("div", { className: "DMSans_16_500  text-center txt_primaryGrey" },
                "Your Ledger Report is ",
                React.createElement("br", null),
                " successfully downloaded"));
        if (emailCheck)
            return (React.createElement("div", { className: "DMSans_16_500 text-center txt_primaryGrey" },
                "Your Ledger Report is successfully shared with ",
                React.createElement("br", null),
                device && (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement("div", { className: "txt-midnight-blue" }, di.ledger.emailList.length <= 3 ? (di.ledger.emailList.join()) : (React.createElement(React.Fragment, null,
                    di.ledger.emailList.slice(0, 3).join(),
                    React.createElement(GenericTooltip, { placement: "right", button: React.createElement("span", null,
                            "and",
                            " ",
                            React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline" },
                                di.ledger.emailList.length - 3,
                                " More",
                                " ",
                                di.ledger.emailList.length - 3 === 1
                                    ? "email"
                                    : "emails")), toolTipText: React.createElement(React.Fragment, null, di.ledger.emailList.slice(3).map((x) => (React.createElement("div", null, x)))), triggerType: "click", toolTipClassName: "download-email-tooltip", externalClassName: "remove-btn-props" }))))) : (React.createElement("div", { className: "txt-midnight-blue" }, di.ledger.emailList.length <= 3 || showAllEmails ? (di.ledger.emailList.map((item, index) => (React.createElement("div", { key: index }, index < di.ledger.emailList.length - 1
                    ? `${item}, `
                    : item)))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", null, di.ledger.emailList.slice(0, 3).join(", ")),
                    React.createElement("div", null,
                        "and",
                        " ",
                        React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline", onClick: () => {
                                setShowAllEmails((prevValue) => !prevValue);
                            } },
                            di.ledger.emailList.length - 3,
                            " More",
                            " ",
                            di.ledger.emailList.length - 3 === 1
                                ? "email"
                                : "emails"))))))));
    };
    const customDisableSubmit = (fromDate, toDate) => {
        if (((props.accType === ILoginAccountTypes.COMEQ &&
            props.COMEQTOGGLE === ILoginAccountTypes.CO) ||
            props.accType === ILoginAccountTypes.CO) &&
            internalStartDate < moment("1 Sep 2019").toDate() &&
            internalEndDate > moment("1 Sep 2019").toDate())
            return true;
        else if (fromDate &&
            toDate &&
            moment(toDate).diff(moment(fromDate), "years") > 1)
            return true;
        return false;
    };
    const showFDotCounter = () => {
        var _a, _b;
        if (filterData) {
            let total = 0;
            for (let key in filterData) {
                if (key == ((_b = (_a = di.ledger.filterState) === null || _a === void 0 ? void 0 : _a.productAssetFilter) === null || _b === void 0 ? void 0 : _b.name))
                    continue;
                if (filterData[key] &&
                    filterData[key].filters &&
                    filterData[key].filters.length > 0) {
                    total =
                        total +
                            filterData[key].filters.filter((tags) => tags === null || tags === void 0 ? void 0 : tags.selected).length;
                }
            }
            return total;
        }
    };
    const clearSorting = () => {
        props.setshowFilterAssetDropdown(false);
        props.setSortOrFilterActiveKey(SORTFILTERTABS.SORT);
        setFinalSortState({
            key: "rowNumber",
            order: ESortOrder.ASC,
            orderText: {
                asc: "High to Low",
                desc: "Low to High",
            },
            title: "rowNumber",
        });
        setSortState((prevState) => {
            return prevState.map((record) => {
                var _a;
                if (((_a = record === null || record === void 0 ? void 0 : record.list) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    record.list.map((item) => {
                        item.order = ESortOrder.UNCHANGED;
                        return item;
                    });
                }
                return record;
            });
        });
    };
    const updateFilterMob = (filterState) => {
        setStateUpdateFilter(filterState);
        props.setSortOrFilterActiveKey(SORTFILTERTABS.FILTER);
        props.setSelectedFilterTray({
            simpleFilter: true,
            assetFilter: false,
        });
        let voucher = filterState === null || filterState === void 0 ? void 0 : filterState.find((x) => x.eventKey === "Voucher");
        let exchange = filterState === null || filterState === void 0 ? void 0 : filterState.find((x) => x.eventKey === "Exchange");
        if (voucher && exchange)
            di.ledger.getFilteredLedgerDetails(new FilterData(new Filters(voucher.eventKey, voucher.list.map((x) => {
                return {
                    title: x.title,
                    key: x.key,
                    selected: x.selected,
                };
            })), new Filters(exchange.eventKey, exchange.list.map((x) => {
                return {
                    title: x.title,
                    key: x.key,
                    selected: x.selected,
                };
            })), props.filters.productAssetFilter));
    };
    React.useEffect(() => {
        function handleClickOutside(event) {
            if (filterRef.current && !filterRef.current.contains(event.target))
                props.setshowFilterAssetDropdown(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [filterRef]);
    React.useEffect(() => {
        setFilterData((prevState) => {
            let state = {
                simpleFilter: props.filters.simpleFilter,
                assetFilter: props.filters.assetFilter,
            };
            state.simpleFilter.filters.forEach((m) => {
                if (VoucherFilterSession) {
                    VoucherFilterSession[0].value.forEach((x) => {
                        if (x === m.key)
                            m.selected = true;
                    });
                }
            });
            state.assetFilter.filters.forEach((m) => {
                if (ExchangeFilterSession) {
                    ExchangeFilterSession[0].value.forEach((x) => {
                        if (x === m.key)
                            m.selected = true;
                    });
                }
            });
            return state;
        });
        setStateUpdateFilter((prevState) => {
            let Voucher = [];
            let Exchange = [];
            let currentTab = `?reportName=${reportName}&tab=${tabname}`;
            Voucher = props.filters.simpleFilter.filters.map((x) => {
                return {
                    title: x.title,
                    key: x.key,
                    selected: x.selected,
                };
            });
            Exchange = props.filters.assetFilter.filters.map((x) => {
                return {
                    title: x.title,
                    key: x.key,
                    selected: x.selected,
                };
            });
            return [
                {
                    filterName: "Voucher",
                    eventKey: "Voucher",
                    list: Voucher,
                    route: currentTab,
                    selectType: "checkbox",
                    type: "checkbox",
                    showFDot: Voucher.some((x) => x.selected === true),
                },
                {
                    filterName: "Exchange",
                    eventKey: "Exchange",
                    list: Exchange,
                    route: currentTab,
                    selectType: "checkbox",
                    type: "checkbox",
                    showFDot: Exchange.some((x) => x.selected === true),
                },
            ];
        });
    }, [
        props.filters,
        props.selectedSegmentFilter,
        props.showFilterAssetDropdown,
    ]);
    React.useEffect(() => {
        props.setShowFDot(showFDotCounter());
    }, [filterData]);
    React.useEffect(() => {
        downloadRestrictionForComm(props.accType, props.COMEQTOGGLE);
        setInternalEndDate(props.endDate);
        setInternalStartDate(props.startDate);
    }, [props.downloadPopUp]);
    React.useEffect(() => {
        let sortedData = mainDI.common.getSortedData(detail, finalSortState.order !== 0 && finalSortState.order === 1, finalSortState.key, finalSortState.type);
        di.ledger.sortLedgerDetails(sortState, finalSortState, sortedData);
    }, [sortState, finalSortState]);
    React.useEffect(() => {
        //init sorting
        if (finalSortState.key === "rowNumber")
            setSortState((prevState) => {
                return prevState.map((record) => {
                    var _a;
                    if (((_a = record === null || record === void 0 ? void 0 : record.list) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        record.list.map((item) => {
                            item.order = ESortOrder.UNCHANGED;
                            return item;
                        });
                    }
                    return record;
                });
            });
    }, [props.showFilterAssetDropdown]);
    React.useEffect(() => {
        //reset sort filter on date change
        if (!(device === null || device === void 0 ? void 0 : device.isDesktop)) {
            setStateUpdateFilter((prevState) => {
                let Voucher = [];
                let Exchange = [];
                let currentTab = `?reportName=${reportName}&tab=${tabname}`;
                Voucher = props.filters.simpleFilter.filters.map((x) => {
                    return {
                        title: x.title,
                        key: x.key,
                        selected: false,
                    };
                });
                Exchange = props.filters.assetFilter.filters.map((x) => {
                    return {
                        title: x.title,
                        key: x.key,
                        selected: false,
                    };
                });
                return [
                    {
                        filterName: "Voucher",
                        eventKey: "Voucher",
                        list: Voucher,
                        route: currentTab,
                        selectType: "checkbox",
                        type: "checkbox",
                        showFDot: Voucher.some((x) => x.selected === true),
                    },
                    {
                        filterName: "Exchange",
                        eventKey: "Exchange",
                        list: Exchange,
                        route: currentTab,
                        selectType: "checkbox",
                        type: "checkbox",
                        showFDot: Exchange.some((x) => x.selected === true),
                    },
                ];
            });
            clearSorting();
            //popup dates
            setInternalEndDate(props.endDate);
            setInternalStartDate(props.startDate);
        }
    }, [props.startDate, props.endDate]);
    return (React.createElement(React.Fragment, null,
        (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement(Ledger_CP_Header, { startDate: props.startDate, setStartDate: props.setStartDate, endDate: props.endDate, setEndDate: props.setEndDate, MTFToggle: props.MTFToggle, setMTFToggle: props.setMTFToggle, nextFinYear: props.nextFinYear, setNextFinYear: props.setNextFinYear, finYear: props.finYear, setFinYear: props.setFinYear, selectedTab: props.selectedTab, openCalendarDrawer: props.openCalendarDrawer, setOpenCalendarDrawer: props.setOpenCalendarDrawer, openCalendar: props.openCalendar, setOpenCalendar: props.setOpenCalendar, setshowFilterAssetDropdown: props.setshowFilterAssetDropdown, setDownloadPopUp: props.setDownloadPopUp, accType: props.accType, COMEQTOGGLE: props.COMEQTOGGLE, filterData: filterData, showFilterAssetDropdown: props.showFilterAssetDropdown, selectedSegmentFilter: props.selectedSegmentFilter, setSelectedSegmentFilter: props.setSelectedSegmentFilter, segmentFilterList: props.segmentFilterList, setSegmentFilterList: props.setSegmentFilterList, showFDot: props.showFDot, allowMTF: props.allowMTF, accCode: props.accCode, setAccCode: props.setAccCode, setOpenFamilyDrop: props.setOpenFamilyDrop, openFamilyDrop: props.openFamilyDrop, handleFamilyApply: props.handleFamilyApply })),
        device && device.isDesktop ? (React.createElement("div", { className: "light-backdrop-modal" },
            React.createElement(EdModal, { show: props.downloadPopUp, setShow: props.setDownloadPopUp, size: "modal-md modal-dialog-centered", iconimage: true, modalTitle: "commonnew-modal-download-popup modalDPTitle commonmodal gray-modal report-common-modal", icon: "edel-icon-download-color-new", iconClass: "gap-8 icon-new-20", paths: threePaths, title: "Download Ledger Report", showFooter: false, DisableOutsideClickClose: true },
                React.createElement("div", { className: "downloadHoldingDesk taxreport" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-12 col-lg-12 downloadHoldingDesk-form common-reports-download-mail ledger-download-modal" },
                            React.createElement(DownloadReportPopupDesk, { startDate: internalStartDate, endDate: internalEndDate, openCalendar: props.openCalendar, setOpenCalendar: props.setOpenCalendar, setEndDate: setInternalEndDate, setStartDate: setInternalStartDate, showLoader: downloadLoader, setShowLoader: setDownloadLoader, setDownloadSuccess: setDownloadSuccess, setDownloadFail: setDownloadFail, setOperation: setOperation, showdate: false, withEndDate: true, submit: downloadAndEmailLedger, reportType: undefined, resetFields: props.downloadPopUp, setDownloadCheck: setDownloadCheck, setEmailCheck: setEmailCheck, submitBtnText: DownloadSubmitButtonText(), customDisableSubmit: customDisableSubmit, minDate: downloadRestrictionForComm(props.accType, props.COMEQTOGGLE), PDF_or_Excel: ReportType.PDF, isAdditionalMsg: (fromDate, toDate) => moment(toDate).diff(moment(fromDate), "years") > 1
                                    ? DateRangeExceedsOneYear
                                    : null }))))),
            downloadLoader && (React.createElement("div", { className: "modalBackground loader-red-common common-new-modal-designs" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(PopupLoader, { messageReactNode: React.createElement("label", { className: "update-message" },
                            " ",
                            "Your Ledger Report is getting prepared to",
                            " ",
                            loaderMessage()), Title: modalTitleDwnldEmail(), isDownloadIcon: true, goBack: () => props.setDownloadPopUp(false) })))),
            downloadSuccess && (React.createElement("div", { className: "modalBackground  common-new-modal-designs" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(SuccessPopup, { setDownloadSuccess: setDownloadSuccess, operation: operation, Title: modalTitleDwnldEmail(), sendBack: true, isDownloadIcon: true, goBackText: true, goBack: () => props.setDownloadPopUp(false), messageReactNode: downloadSuccessNode() })))),
            downloadFail && (React.createElement("div", { className: "modalBackground common-new-modal-designs" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(PopupFail, { setDownloadFail: setDownloadFail, Title: modalTitleDwnldEmail(), operation: operation, sendBack: true, isDownloadIcon: true, goBackText: true, message: `<span class='DMSans_16_500'>We ran in to some technical difficulties, ${FailureMessage()} </span>`, goBack: () => props.setDownloadPopUp(false) })))))) : (React.createElement("div", { className: `common-mob-smallcase-popup-download ${!isClientLogin && "not-client-login"} mb-genericSidebar` },
            React.createElement(GenericDrawer, { show: props.downloadPopUp, setShow: props.setDownloadPopUp, parentClass: "z-index-high download-ledger commonnew-download-report-drawer", headerComp: React.createElement("span", { className: "DMSanN_16_400 txt-midnight-blue px-3" }, "Download Report"), bodyComp: React.createElement("div", { className: "common-reports-download-mail" },
                    React.createElement(CommonDownloadReport, { parentClass: "midnightblue-theme", setDownloadSuccess: setDownloadSuccess, setShowLoader: setDownloadLoader, setDownloadFail: setDownloadFail, showLoader: downloadLoader, downloadSuccess: downloadSuccess, downloadFail: downloadFail, setOperation: setOperation, operation: operation, startDate: internalStartDate, endDate: internalEndDate, setStartDate: setInternalStartDate, setEndDate: setInternalEndDate, withEndDate: true, submitDownload: downloadAndEmailLedger, reportName: ReportName.LEDGER, goBack: () => {
                            props.setDownloadPopUp(false);
                        }, messageReactNode: downloadSuccessNode(), setEmailCheck: setEmailCheck, setDownloadCheck: setDownloadCheck, PDF_or_Excel: ReportType.PDF, minDate: downloadRestrictionForComm(props.accType, props.COMEQTOGGLE), isAdditionalMsg: (fromDate, toDate) => moment(toDate).diff(moment(fromDate), "years") > 1
                            ? DateRangeExceedsOneYear
                            : null, customDisableSubmit: customDisableSubmit })) }),
            React.createElement(Drawer, { isVisible: downloadLoader || downloadSuccess || downloadFail, onClose: () => {
                    closeDrawerLoader();
                    closeDrawerDownloadS();
                    closeDrawerFail();
                }, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper backdrop_blur" },
                downloadLoader && (React.createElement(SmcasePopupLoaderMob, { Title: modalTitleDwnldEmail(), closeDrawer: closeDrawerLoader, message: `Your Ledger Report is getting prepared to ${loaderMessage()}` })),
                downloadSuccess && (React.createElement(SmcasePopupSuccessMob, { messageReactNode: downloadSuccessNode(), Title: modalTitleDwnldEmail(), closeDrawer: closeDrawerDownloadS, operation: operation, pageName: ReportName.LEDGER, isDownloadIcon: true, sendBack: true, goBackText: true, goBack: () => props.setDownloadPopUp(false) })),
                downloadFail && (React.createElement(SmcasePopupFailMob, { closeDrawer: closeDrawerFail, operation: operation, pageName: ReportName.LEDGER, goBack: () => props.setDownloadPopUp(false), sendBack: true, goBackText: true, message: `<span class='DMSans_16_500'>We ran in to some technical difficulties, ${FailureMessage()} </span>` }))))),
        device && device.isDesktop ? (props.showFilterAssetDropdown && (React.createElement("div", { className: "adjust-filter-dropdown", ref: filterRef },
            React.createElement(LedgerFilter, { setshowFilterAssetDropdown: props.setshowFilterAssetDropdown, filterData: filterData, setFilterData: setFilterData, applyFilter: applyFilter, showAsset: filterData.assetFilter.filters.length > 0, setShowFDot: props.setShowFDot, dynamicFiltersName: dynamicLedgerFilters, parentClass: "filterasset-new-theme", replacedFilterName: {
                    simpleFilter: "simpleFilter",
                    assetFilter: "assetFilter",
                }, selectedFilterTray: props.selectedFilterTray })))) : (React.createElement(GenericDrawer, { show: props.showFilterAssetDropdown, setShow: props.setshowFilterAssetDropdown, parentClass: "z-index-high bg_porcelain", headerComp: React.createElement("div", { className: "d-flex flex-row justify-content-between sort-filter-ledgerhead" },
                React.createElement("span", { className: "DMSan_16_700  " }, "Sort and Filter"),
                React.createElement("span", null,
                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Clear All", className: "w-100", onClick: () => {
                            setStateUpdateFilter((prevState) => {
                                return prevState.map((x) => {
                                    let currentTab = `?reportName=${reportName}&tab=${tabname}`;
                                    return {
                                        filterName: x.filterName,
                                        eventKey: x.eventKey,
                                        route: currentTab,
                                        list: x.list.map((y) => {
                                            return {
                                                title: y.title,
                                                key: y.key,
                                                selected: false,
                                            };
                                        }),
                                        selectType: x.selectType,
                                        type: x.type,
                                        showFDot: false,
                                    };
                                });
                            });
                            clearSorting();
                            di.ledger.clearAllFilters();
                        } }))), bodyComp: React.createElement(SortFilter
            //sort props
            , { 
                //sort props
                sortList: sortlistLedger, sortState: sortState, resetSort: clearSorting, setSortState: setSortState, handelSorting: sortLedgerDetailsReport, setOpenSort: () => { }, openDrawer: props.showFilterAssetDropdown, setOpenDrawer: props.setshowFilterAssetDropdown, 
                // Filter Propes
                filterState: stateUpdateFilter, updateFilterState: updateFilterMob, cancelAndApply: true, hideSortDrawerHeader: true, sortOrFilterActiveKey: props.sortOrFilterActiveKey, activeKey: props.selectedFilterTray.simpleFilter ? "Voucher" : "Exchange", setActiveKey: (key) => {
                    props.setSelectedFilterTray({
                        simpleFilter: key === "Voucher",
                        assetFilter: key === "Exchange",
                    });
                } }) })),
        (device === null || device === void 0 ? void 0 : device.isDesktop) &&
            props.selectedTab == LedgerTabsType.DETAILED &&
            props.showFDot > 0 && (React.createElement("div", { className: "filter-tags" }, filterData &&
            Object.entries(filterData).map((val) => {
                if (val[1] && val[1].filters)
                    return val[1].filters.map((tags, idxb) => {
                        var _a, _b;
                        if (val[1].name ===
                            ((_b = (_a = di.ledger.filterState) === null || _a === void 0 ? void 0 : _a.productAssetFilter) === null || _b === void 0 ? void 0 : _b.name))
                            return;
                        return (tags.selected && (React.createElement("div", { key: idxb },
                            React.createElement(FilterLabels, { LabelText: tags.title, closeBtn: true, FilterAction: (filtername) => di.ledger.removeOneFilter(filtername) }))));
                    });
            })))));
};
export default LedgerCommonPanel;
